import axios, { AxiosError } from "axios";

export const http = axios.create({
    withCredentials: true,
    headers: { Accept: "application/json" },
    // ASP.NET binds repeated keys, not the bracketed form axios uses by default
    paramsSerializer: { indexes: null },
});

export function isStatus(error: unknown, status: number): boolean {
    return error instanceof AxiosError && error.response?.status === status;
}

export function errorMessage(error: unknown): string | null {
    if (error instanceof AxiosError) {
        const data: unknown = error.response?.data;
        if (typeof data === "object" && data !== null && "error" in data && typeof data.error === "string") {
            return data.error;
        }
    }
    return null;
}
